import * as React from 'react';
import { GridNextPrevMonthDayProps } from '../../components/grid/next-prev-month-day';

//NOTE: This view is exactly similar to the grid-day view with a minor change but has been created to allow 
//the calendar app to be upgrade proof

import * as moment from 'moment';
import GridEventView from '../../components/grid/event';

const GridNextPrevMonthDayView: React.StatelessComponent<GridNextPrevMonthDayProps> = props => {
    const dateMoment = moment(props.day.date);

    return (
        <li className={`ace-cal-grid-day other-month`} aria-labelledby={`Day-${dateMoment.format("X")}`}>
            {
                props.day.events.length > 0 ?
                    <article className="ace-cal-grid-day-content">
                        <span aria-hidden="true" role="presentation" className="ace-cal-grid-day-date">{dateMoment.format("DD")}</span>
                        <h4 id={`Day-${dateMoment.format("X")}`} className="visually-hidden">
                            {
                                <span role="text">
                                    {`${dateMoment.format("dddd, MMMM")} ${dateMoment.format("D")}`}
                                    <span>{`: ${props.day.events.length} ${props.day.events.length > 2 ? props.text.eventsPluralString : props.text.eventSingleString}`}</span>
                                </span>
                            }
                        </h4>
                        <ul className="ace-cal-grid-day-content-list">
                            {
                                props.day.events.map(event => <GridEventView key={event.id} event={event} />)
                            }
                        </ul>
                    </article>
                    :
                    <div className="ace-cal-grid-day-content">
                        <span className="ace-cal-grid-day-date" id={`Day-${dateMoment.format("X")}`} role="text"><span className="visually-hidden">{`${dateMoment.format("dddd, MMMM")} `}</span>{dateMoment.format("D")}</span>
                    </div>
            }
        </li>
    );
}

export default GridNextPrevMonthDayView;